import React from "react";

import SVGIcon from "components/Icons/SVGIcon";

import { OverlayTrigger, Tooltip } from "react-bootstrap";

import moment from "services/locale/momentInit.js";

const SiteOnTestEventCell = ({
  event,
  overrideColour,
  alarm_text,
  date,
  timezone,
}) => {
  let Content = <div></div>;
  let colour = overrideColour || "#8e44ad";

  if (typeof event !== "undefined") {
    try {
      const { icon } = event;
      colour = overrideColour || event.colour || "#8e44ad";

      const localDate = new moment(date);
      const timezoneDate = timezone ? new moment.utc(localDate).tz(timezone) : localDate;
      const localTimezoneText = moment.tz.guess();
      
      const Icon = icon ? (
        <div
          className="svg-container-alarm"
          style={{
            padding: "6px",
            minWidth: "32px",
            minHeight: "32px",
            background: event.colour,
            borderRadius: "16px",
          }}
        >
          <div
            id={icon}
            className="svg-icon"
            style={{
              width: "20px",
              height: "20px",
              margin: "0 auto",
              position: "relative",
              left: "2px"
            }}
          >
            <SVGIcon type={icon} color={"#ffffff"} />
          </div>
        </div>
      ) : null;

      const EventComponent = (
        <div>
          <span style={{
            fontWeight: "bold",
          }}>{`${timezoneDate.format("HH:mm")}`}</span>
        </div>
      );

      Content = (
        <div className="d-flex justify-content-between">
          {
            alarm_text
              ? <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top" style={{ pointerEvents: "none" }}>
                      <div style={{ fontSize: "12px" }} className="py-1">
                        {alarm_text}
                      </div>
                    </Tooltip>
                  }
                ><span>{Icon}</span></OverlayTrigger>
              : Icon
          }
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="tooltip-top" style={{ pointerEvents: "none" }}>
                <div style={{ fontSize: "12px" }} className="py-1">
                {`${localDate.format("HH:mm DD/MM/YYYY")} ${localTimezoneText}`}
                </div>
              </Tooltip>
            }
          >
            <div
              style={{ paddingTop: "6px", paddingRight: "10px" }}
            >{EventComponent}</div>
          </OverlayTrigger>
        </div>
      )

    } catch(error) {
      console.log("SiteOnTestEventCell error: " + error);

      Content = <div></div>;
    }
  }

  return <div
    style={{
      backgroundColor: colour,
      borderRadius: "16px 0 0 16px",
      height: "32px",
    }}
    className="inner text-light"
  >{Content}</div>
};

export { SiteOnTestEventCell };